import React, { Component } from 'react'
import Button from '../components/Button'
import { connect } from 'react-redux';
import { getBlogs } from '../actions/MainAction';
import Card from '../components/Card';
import { changeStateValue } from '../redux/MainReducer';
export class BlogPage extends Component {
    componentDidMount(){
        this.props.getBlogs();
    }
    editModalBtn=(data='')=>{
        this.props.changeStateValue({
            name:'modalData',
            value: {
              position: true,
              id: data?.id?data?.id:'',
              title: data?.title?data?.title:'',
              path: data?.path?data?.path:'',
              description: data?.description?data?.description:'',
              image_full_url: data?.image_full_url?data?.image_full_url:'',
              read_count: data?.read_count? data?.read_count:'0',
              unrequire: ["unrequire", "funcParams", "id", "image_full_url"],
              afterCallFunction: this.props.getBlogs,
              funcParams:[],
              url: data?.id? `blog/${data?.id}`: 'blog',
              _method:  data?.id? 'put':'post'
            }
          })
    }
    getAfterChange=()=>{
        this.props.getBlogs();
    }
  render() {
    const {blogs} = this.props;
    return (
        <div className='container  ml-auto mr-auto mt-10'>
        <div className='flex justify-between items-center'>
            <h2 className='text-xl text-blue-700 font-semibold'>Blog Page</h2>
            <Button title="Add Blog" onClick={this.editModalBtn.bind(this)} className=" bg-blue-700"  />
        </div>
        <div className='grid grid-cols-4 gap-10 mt-10'>
           {
            blogs?.map((data, i)=>{
                return(
                    <Card
                        image={data?.image_full_url}
                        key={i}
                        title={data?.title}
                        editBtnData={data}
                        editModalBtn={this.editModalBtn}
                        url={`blog/${data?.id}`}
                        getAfterChange={this.getAfterChange}
                    />
                )
            })
           }
           
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) =>({
    blogs: state.Data.blogs
});
const mapDispatchToProps = {getBlogs, changeStateValue}
export default connect(mapStateToProps, mapDispatchToProps)(BlogPage)